/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Notification from '@zg-rentals/multibrand-ui/lib/Notification';

// TODO: update mui Row, Col to use zrs-comet
import { Container } from '@zillow/zrs-comet';

// Constants
import { USER_MANAGEMENT_PAGE } from 'app/shared/constants/RouteConstants';

// Components
import PermissionCheck from 'app/shared/components/PermissionCheck';
import HeadWrapper from 'app/shared/components/HeadWrapper';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

// Selectors
import { RoutingSelectors, UserManagementSelectors } from 'app/shared/selectors';

import pathsManifest from 'app/shared/pathsManifest';

// Actions
import UserManagementActions from 'app/shared/actions/UserManagementActions';

import UsersPage from 'app/shared/containers/UsersPage';
import ActivityHistoryPage from 'app/shared/containers/ActivityHistoryPage';

import UserManagementNav from './UserManagementNav';

// Stylesheets
import './style.scss';

const paths = pathsManifest.getAllPaths();

const DEFAULT_PAGE_TITLE = 'User management';

const propTypes = {
    companyUsers: PropTypes.object,
};

const defaultProps = {
    companyUsers: {},
};

const contextTypes = {
    router: PropTypes.object.isRequired,
    paths: PropTypes.object,
};

const UserManagementPage = ({
    companyUsers,
    dispatch,
    company,
    activeTab,
}) => {
    React.useEffect(() => {
        dispatch(UserManagementActions.getCompany());
        dispatch(UserManagementActions.getUserManagementProfiles());
    }, []);

    const getSectionUrl = (section) => {
        const baseDetailsUrl = paths.userManagementPage;
        return `${baseDetailsUrl}/${section}([?].*)?`;
    };

    const renderChildRoutes = () => {
        // child paths
        const childPathUsers = getSectionUrl(paths.userManagementUsers);
        const childPathPending = getSectionUrl(paths.userManagementPending);
        const childPathActivity = getSectionUrl(paths.userManagementActivity);
        return (
            <Switch>
                <Route component={UsersPage} path={childPathUsers} />
                <Route component={UsersPage} path={childPathPending} />
                <Route component={ActivityHistoryPage} path={childPathActivity} />
            </Switch>
        );
    };

    const renderContent = () => {
        const { notification } = companyUsers;
        return (
            <PermissionCheck route={USER_MANAGEMENT_PAGE}>
                <Container className="UserManagementPage-container">
                    <StyledContainer className="UserManagementPage-card" borderFull={true} borderRounded={true}>
                        {notification && (
                            <Row>
                                <Col xs={12}>
                                    <Notification
                                        onClose={() => dispatch(UserManagementActions.setUsersNotification(null))}
                                        type="success"
                                    >
                                        {companyUsers.notification}
                                    </Notification>
                                </Col>
                            </Row>
                        )}
                        <Row noPadding={true}>
                            <Col xs={12}>
                                <Text className="UserManagementPage-heading" type="h1">
                                    {DEFAULT_PAGE_TITLE}
                                </Text>
                            </Col>
                        </Row>
                        <UserManagementNav
                            company={company}
                            activeTab={activeTab}
                        />
                        {renderChildRoutes()}
                    </StyledContainer>
                </Container>
            </PermissionCheck>
        );
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div className="UserManagementPage">
                <HeadWrapper title={DEFAULT_PAGE_TITLE} />
                {renderContent()}
            </div>
        </AuthCheckWrapper>
    );
};

const mapStateToProps = state => ({
    router: RoutingSelectors.makeRouting(state),
    companyUsers: UserManagementSelectors.makeCompanyUsers(state),
    activeTab: UserManagementSelectors.makeActiveTab(state),
    company: UserManagementSelectors.makeCompany(state),
});

UserManagementPage.contextTypes = contextTypes;
UserManagementPage.propTypes = propTypes;
UserManagementPage.defaultProps = defaultProps;

export { UserManagementPage };
export default connect(mapStateToProps)(UserManagementPage);
